import { jwtDecode } from "jwt-decode";
import { memoize, partial } from "lodash";
import { objectIndex } from "./objectIndexer";
import * as storage from "./sessionStorage";
import { v4 as uuid } from "uuid";
import { isUndefined } from "lodash";
import { mapProps } from "recompose";

const hashArray = (...args) =>
  args
    .map((arg) => {
      switch (typeof arg) {
        case "function":
        case "object":
          return arg ? objectIndex(arg) : "null";
        default:
          return arg;
      }
    })
    .join();

export const mpartial = memoize(
  (...args) => partial(...args),
  (...args) => hashArray(...args) // maybe refactor using pretty-format
);

export const replace = (array, oldValue, newValue) =>
  array.map((value) => (value === oldValue ? newValue : value));

export const noop = () => {};

export const identity = (o) => o;

export const contains = (items, id) => items.indexOf(id) !== -1;

export const removePrefix = (string = null, prefix) =>
  string !== null && string.startsWith(prefix)
    ? string.substring(prefix.length)
    : string;

export const join =
  (...fns) =>
  (...args) =>
    fns.filter((fn) => fn instanceof Function).forEach((fn) => fn(...args));

export const getDecodedToken = () => {
  const token = storage.get("token");
  if (!token) {
    return null;
  }
  return jwtDecode(token);
};

export const errorRoute = (err) => {
  console.error("Dynamic page loading failed", err); // eslint-disable-line no-console
};

export const loadRoute = (cb) => (module) => cb(null, module.default);

export const idObj = (obj = {}) =>
  isUndefined(obj.id) ? { id: uuid(), ...obj } : obj;

export const formWrapper = mapProps((formProps) => {
  const { input, meta, ...rest } = formProps;
  return {
    errorText: meta.touched && meta.error,
    value: input.value,
    onChange: input.onChange,
    name: input.name,
    ...rest,
  };
});
